import { AnyAction } from '@reduxjs/toolkit';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../apiServices';
import { BookActions } from './BookActions';
import { setArchivedBooks, setBookInvitedTo, setMyBooks, setTemplateBooks } from './BookSlice';
import { setLoading } from '../common/CommonSlice';
import { parseToJSON } from '../../../views/book-create/Cover/components/Block/Block';
import dayjs from 'dayjs';

function* getMyBooksSaga(action: AnyAction): any {
  const { loading } = action.payload;
  if (loading) {
    try {
      yield put(setLoading(true));
      const { myBooks, bookInvitedTo, archived, template } = yield call(api.book.list);
      yield put(
        setMyBooks([
          ...myBooks
            .filter((b: any) => !b.isDeleted)
            .map((book: any) => ({ ...book, interiorPageDimension: parseToJSON(book.interiorPageDimension) })),
        ]),
      );
      yield put(
        setBookInvitedTo([
          ...bookInvitedTo.map((book: any) => ({ ...book, interiorPageDimension: parseToJSON(book.interiorPageDimension) })),
        ]),
      );
      yield put(
        setArchivedBooks([
          ...archived.map((book: any) => {
            const old = dayjs(1726167333701).diff(dayjs(book.created_at), 'day') > 0; // Old template
            return { ...book, old };
          }),
        ]),
      );
      yield put(
        setTemplateBooks([
          ...template.books.map((book: any) => {
            const old = dayjs(1726167333701).diff(dayjs(book.created_at), 'day') > 0; // Old template
            return { ...book, old };
          }),
          ...template.pages,
        ]),
      );
    } catch (error) {
      console.log(error);
    } finally {
      yield put(setLoading(false));
    }
  } else {
    try {
      const { myBooks, bookInvitedTo } = yield call(api.book.list);
      yield put(setMyBooks([...myBooks.map((book: any) => ({ ...book, interiorPageDimension: parseToJSON(book.interiorPageDimension) }))]));
      yield put(
        setBookInvitedTo([
          ...bookInvitedTo.map((book: any) => ({ ...book, interiorPageDimension: parseToJSON(book.interiorPageDimension) })),
        ]),
      );
    } catch (error) {
      console.log(error);
    }
  }
}

function* updateCoverThumbnailSaga(action: AnyAction): any {
  try {
    yield call(api.book.updateCoverThumbnail, action.payload);
  } catch (error) {
    console.log(error);
  }
}

export function* bookSaga() {
  yield all([takeLatest(BookActions.getMyBooks, getMyBooksSaga), takeLatest(BookActions.updateCoverThumbnail, updateCoverThumbnailSaga)]);
}
